import React from 'react';
import NewDataResult_Comp from '../../Components/NewDataResult/NewDataResult';
import Dashboard_Comp from '../../Components/Dashboard/Dashboard';

function NewCaseResult() {
  return (
    <>
    <Dashboard_Comp>
    <NewDataResult_Comp />
    </Dashboard_Comp>
    </>
  )
}

export default NewCaseResult;